const stoveOffset = 325;

const mirroredSide = (side, mirrored) => {
    if (!mirrored) return side;
    if (side === "left") return "right";
    if (side === "right") return "left";
    if (side === "backLeft") return "backRight";
    if (side === "backRight") return "backLeft";
    return side;
};

export const getBenchModelDefaultPositions = (shape, measurements, mirrored) => {
    const saunaWidth = Number(measurements.doorWallWidth) || 0;
    const saunaDepth = Number(measurements.depth) || 0;
    const doorWidth = Number(measurements.doorWidth) || 0;
    const doorPosition = mirroredSide((shape && shape.defaultDoorPosition) || "center", mirrored);
    const stovePosition = mirroredSide((shape && shape.defaultStovePosition) || "right", mirrored);
    const availableDoorSpace = Math.max(0, saunaWidth - doorWidth);

    let doorFromLeft = Math.round(availableDoorSpace / 2);
    if (doorPosition === "left") doorFromLeft = 0;
    if (doorPosition === "right") doorFromLeft = availableDoorSpace;

    let stoveX = saunaWidth / 2;
    let stoveY = saunaDepth - stoveOffset;
    if (stovePosition === "left") stoveX = stoveOffset;
    if (stovePosition === "right") stoveX = saunaWidth - stoveOffset;
    if (stovePosition === "backWallCenter") stoveY = stoveOffset;
    if (stovePosition === "backLeft") {
        stoveX = stoveOffset;
        stoveY = stoveOffset;
    }
    if (stovePosition === "backRight") {
        stoveX = saunaWidth - stoveOffset;
        stoveY = stoveOffset;
    }

    return {
        doorFromLeft,
        stovePosition: {
            x: stoveX,
            y: stoveY
        }
    };
};

export const positionsMatch = (first, second) => Boolean(first && second) &&
    Number(first.x) === Number(second.x) &&
    Number(first.y) === Number(second.y);
